import React from 'react';

import AspectRatio from '@/components/common/AspectRatio';

import css from './FeaturedParks.module.css';

const FeaturedParks = props => {
  const { section } = props;

  return (
    <div className={css.featuredContent}>
      {section.popular_parks.slice(0, 9).map(park => {
        return (
          <a href={park.url} className={css.featuredContainer} key={park.image}>
            <div className={css.featuredCard}>
              <div className={css.featuredImage}>
                <AspectRatio ratio={'16:9'} hasImageHover={true}>
                  <img src={park.image} loading="lazy" alt={park.title} />
                </AspectRatio>
              </div>
              <div className={css.featuredDetails}>
                <span className={css.featuredTitle}>{park.title}</span>
                <span>{park.state_name}</span>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default FeaturedParks;
